import React from "react";

import { faPenAlt } from "@fortawesome/pro-solid-svg-icons/faPenAlt";
import { faSave } from "@fortawesome/pro-solid-svg-icons/faSave";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

import ButtonBox from "@app/component/ButtonBox";
import layout from "@app/styles/layout";

interface Props {
  onHide: () => void;
  onStartFromScratch: () => void;
  onUseSavedMatching: () => void;
  visible: boolean;
}

const SelectMatchingWayModal: React.FC<Props> = ({
  onHide,
  onStartFromScratch,
  onUseSavedMatching,
  visible,
}) => {
  const intl = useIntl();

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      onCancel={onHide}
      title={intl.formatMessage({
        id: "settings.newImports.config.selectPreferredWayModal.title",
        defaultMessage: "Select your preferred way to match fields",
        description: "Title of imports select prefer way modal",
      })}
      visible={visible}
    >
      <p>
        {intl.formatMessage({
          id: "settings.newImports.config.selectPreferredWayModal.subTitle",
          defaultMessage:
            "Jump-start the field matching process by starting with a previous import matching",
          description: "SubTitle of imports select prefer way modal",
        })}
      </p>
      <Row gutter={layout.spacerXL}>
        <Col xs={12}>
          <ButtonBox
            icon={faPenAlt}
            onClick={onStartFromScratch}
            title={intl.formatMessage({
              id: "settings.newImports.config.selectPreferredWayModal.action.startFromScratch",
              defaultMessage: "Start from scratch",
              description: "Select prefer way modal Start from scratch action",
            })}
          />
        </Col>
        <Col xs={12}>
          <ButtonBox
            icon={faSave}
            onClick={onUseSavedMatching}
            title={intl.formatMessage({
              id: "settings.newImports.config.selectPreferredWayModal.action.useSavedMatching",
              defaultMessage: "Use a saved matching",
              description: "Select prefer way modal Use saved matching",
            })}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default SelectMatchingWayModal;
